import { IsUserLoggedInService } from './../../services/user/is-user-logged-in.service';
import { LoadingService } from 'src/app/services/loading.service';
import { AlertController } from '@ionic/angular';
import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { environment } from 'src/environments/environment';
import { SubSink } from 'subsink';

@Component({
  selector: 'app-membership',
  templateUrl: './membership.page.html',
  styleUrls: ['./membership.page.scss'],
})
export class MembershipPage implements OnInit {
  paymentHandler: any = null;
  pro_package_activated: boolean = false;
  pro_package_expired: boolean = false;
  pro_expire_date: string = '';
  public user_id: string = '';
  table_id: string = 'prctbl_1N67u5BOl1hKOEOnx1jRs1Em';
  subscription = new SubSink();

  plans: any = {
    'basic' : [
      'View Home page, find local events, listings, & event calendars',
      'Receive Event Notifications',
      'View Profiles ( preview Music, Videos, Weekly specials  Social media etc)',
      'Send Tips ( Show support and send tips to Premium accounts)',
      'Watch Video Archives ( Public and Private)',
      'Save Favs accounts, Gain followers & Fans',
      'Sync Google Calendar with Local events'
    ],
    'standard' : [
      'Viewing Home page, finding local events, listings, & event calendars',
      'Receive Event Notifications',
      'View Profiles ( preview Music, Videos, Weekly specials  Social media etc)',
      'Send Tips ( Show support and send tips to accounts)',
      'Watch Video Archives & PPV',
      'Save Favs accounts, Gain followers & Fans',
      'Build & Customize profile',
      'Upload PPV Archives ( public & private videos - CLL gets 25% of PPV) min $3.99',
      'Send “Event Calendar & Upcoming Events” notifications when adding events',
      'Receive push notifications ( followers, favs & more)',
      'Sync Google Calendar with Local events'
    ],
    'premium': [
      'Viewing Home page, finding local events, listings, & event calendars',
      'Receive Event Notifications',
      'View Profiles ( preview Music, Videos, Weekly specials  Social media etc)',
      'Send Tips ( Show support and send tips to accounts)',
      'Watch Video Archives & PPV',
      'Save Favs accounts, Gain followers & Fans',
      'Build & Customize profile',
      'Upload PPV Archives ( public & private videos - CLL gets 25% of PPV) min $3.99',
      'View Video Stats ( see Video Archive & PPV Stats)',
      'Sync Google Calendar with Local events & Send “Event Calendar & Upcoming Events” notifications when adding events',
      'Receive push notifications ( followers, favs & more)',
      'BOOK NOW & BOOKING List enabled ( prices, locations, & more)',
      'View Booking map, Booking request, & Booking notifications',
      'Inbox & direct message other accounts ( Messenger & inbox enabled)',
      'Monetize & Receive Tips ( Your Earnings) - ( DISCLAIMER - TIPS ARE PAID OUT WEEKLY)'
    ]
  };

  constructor(
    private apiService: ApiService,
    private alertController: AlertController,
    private loggedInService: IsUserLoggedInService,
    public loading: LoadingService,
  ) {
  }

  ngOnInit() {
  }

  async ionViewWillEnter(){
    await this.checkUserPackage();
    this.user_id = await this.apiService.getUserId();
    this.invokeStripe();
    this.subscription.sink = this.loggedInService._subscribeStatus.subscribe(
      (value) => {
        this.pro_package_activated = value;
      }
    );
  }

  ionViewWillLeave(){
    this.subscription.unsubscribe();
  }

  checkUserPackage(){
    this.apiService.get('users/subscription-active').subscribe((res) => {
      let expire = res.data.next_payment_date;
      this.pro_expire_date = res.data.next_payment_date;
      var MyDate = new Date();

      MyDate.setDate(MyDate.getDate());

      let today = MyDate.getFullYear() + '-'
                  + ('0' + (MyDate.getMonth()+1)).slice(-2) + '-'
                  + ('0' + MyDate.getDate()).slice(-2);

      let expire_date = new Date(expire);
      let today_date = new Date(today);

      console.log("expire date", expire_date.toISOString(), "today date", today_date.toISOString());

      if(expire && expire_date.toISOString() > today_date.toISOString()){
        this.pro_package_activated = true;
        this.pro_package_expired = false;
        console.log("you package is expired, activate again");
      }else{
        this.pro_package_activated = false;
        this.pro_package_expired = false;
        console.log("your package will expire at " + expire_date);
      }


    })
  }

  /*------------------------------------------
  --------------------------------------------
  makePayment() Function
  --------------------------------------------
  --------------------------------------------*/
  makePayment(amount: any) {
    let myThis = this;
    const paymentHandler = (<any>window).StripeCheckout.configure({
      key: environment.stripe_key,
      locale: 'auto',
      token: function (stripeToken: any) {
        let data = {
          amount: amount,
          token: stripeToken.id,
          last4: stripeToken.card.last4,
          email: stripeToken.email,
        }

        myThis.apiService.post('checkout/upgrade-account', data).subscribe((res) => {
          myThis.loggedInService.updateUserSubscriptionStatus(true);
          let date = res.data.trial_end;
          myThis.pro_expire_date = new Date(date * 1000).toLocaleDateString("en-US");

          // let customer_id = res.data.customer;
          // let stripe = {
          //   customer_id: customer_id,
          //   amount: amount,
          //   transaction_id: res.data.id,
          // }

          // myThis.apiService.put('checkout/update-user-stripe', stripe).subscribe((res) => {
          //   console.log("after updating user data", res);
          //   this.pro_package_activated = true;
          //   this.pro_package_expired = false;
          //   myThis.loggedInService.updateUserSubscriptionStatus(true);
          // });

        });

      },
    });
    paymentHandler.open({
      name: 'Local & Live',
      description: 'Stripe Payment',
      amount: amount * 100,
    });
  }

  /*------------------------------------------
  --------------------------------------------
  invokeStripe() Function
  --------------------------------------------
  --------------------------------------------*/
  invokeStripe() {
    console.log("invoke strip");
    if (!window.document.getElementById('stripe-script')) {
      console.log("create strip script");
      const script = window.document.createElement('script');

      script.id = 'stripe-script';
      script.type = 'text/javascript';
      script.src = 'https://checkout.stripe.com/checkout.js';
      script.onload = () => {
        this.paymentHandler = (<any>window).StripeCheckout.configure({
          key: environment.stripe_key,
          locale: 'auto',
          allow_promotion_codes: true,
          token: function (obj: any) {
            console.log("invokeStripe", obj);
            // alert('Payment has been successfully!');
          },
        });
      };

      window.document.body.appendChild(script);
      console.log("append strip script in body");
    }
  }

  async cancelSubscription(){
    let alert = this.alertController.create({
      // header: 'Unfollow ',
      message: 'Do you want to cancel your subscription?',
      buttons: [
        {
          text: 'Cancel Subscription',
          role: 'Not Now',
          handler: () => {
            this.apiService.delete('checkout/cancel-subscription').subscribe((res) => {
              this.pro_package_activated = false;
              this.pro_package_expired = false;
              this.loggedInService.updateUserSubscriptionStatus(false);
              // this.loggedInService.changeUserStatus(false);
            })
          }
        },
        {
          text: 'Not Now',
          handler: () => {

          }
        }
      ]
    });
    (await alert).present();
  }

  async createSubscriptionCheckout(){
    this.loading.present();
    this.apiService.get('checkout/upgrade-account').subscribe((res) => {
      this.loading.dismiss();
      window.location.href = res.data.url;
      // window.open(res.data.url, '_system', 'location=yes');
      console.log("Here ======>", res.data.url, res);
    },
    error => {
      this.loading.dismiss();
      console.log('oops', error)
    });
  }

}
